angular.module('app.entity.actions').controller('EntityActionsController', [
    '$exceptionHandler',
    'Modal',
    'AccountManager',
    function(
        $exceptionHandler,
        Modal,
        AccountManager
    ) {
        var vm = this;

        vm.showInvalidHelp = function() {
            return Modal.open({
                templateUrl: 'modules/error/components/help-invalid-record/content.html',
                controller: 'HelpInvalidErrorController',
                controllerAs: 'modal',
            }).closePromise
                .catch($exceptionHandler);
        };

        vm.showRevisionInfo = AccountManager.hasPermission('read records revision');
    }]);
